// src/components/TawkToWidget.jsx
import { useEffect } from "react";

const LiveChatWidget = () => {
  useEffect(() => {
    if (document.getElementById("tawk-to-widget")) return;

    // Define Tawk_API and customStyle before loading the script
    
    // Set only mobile style override
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = {
      visibility: {
        mobile: {
          position: 'br',      // Bottom right
          xOffset: 0,
          yOffset: 90,         // Move it up
        }, 
        bubble: {
          rotate: '0deg',
          xOffset: 0,
          yOffset: 0,
        },
      },
    };

    const script = document.createElement("script");
    script.id = "tawk-to-widget";
    script.async = true;
    script.src = "https://embed.tawk.to/687d9bfe3606072bf84a64a5/1j0lainbh";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);
  }, []);

  return null;
};

export default LiveChatWidget;
